<div class="loader-wrapper">
  <div class="loader"></div>
</div>
